export const dateInput = {
    init: function () {
        $('input.datepicker').each(function() {
            $(this).datepicker({ dateFormat: 'yy-mm-dd' });
        })
    },
};
